import CrudActionSetBase from './CrudActionSetBase'

export class OptActionSet extends CrudActionSetBase('opt'){}
export default new OptActionSet()